import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'

import LogIn from '@/components/LogIn'
import SpotContent from '@/components/spotContent'
import SpotPreview from '@/components/preview'

import Usergrd from './usergrd';

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'HelloWorld',
      component: HelloWorld,
      beforeEnter: Usergrd
    },
    {
      path: '/spot/:id',
      name: 'SpotContent',
      component: SpotContent,
      beforeEnter: Usergrd
    },
    {
      path: '/spot/:id/preview',
      name: 'spotPreview',
      component: SpotPreview,
      beforeEnter: Usergrd
    },
    {
      path: '/logIn',
      name: 'LogIn',
      component: LogIn
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js